/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  CenteredContainer,
  Heading,
  VariableText,
} from '../components/Typography';
import styled from 'styled-components';
import Button from '../components/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { RotatingLines } from 'react-loader-spinner';
import { ROUTES } from '../components/Routes';
import { SERVICES } from '../components/Services';
import { get, post } from '../components/ApiHandler/apihandler';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from '../components/Loader/Loader';
import { Box } from '@mui/material';
const NoticeText = styled.p`
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  text-align: center;
  color: #51a69e;
  white-space: pre-wrap;
  width: 50%;
  @media (max-width: 768px) {
    width: auto;
    padding: 0 20px;
  }
`;

const Centered = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  padding-bottom: 75px;
  @media (max-width: 768px) {
    margin-top: 0;
  }
`;
const CenteredNew = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  @media (max-width: 768px) {
    margin-top: 0;
    padding-bottom: 10px;
  }
`;
const LoaderCentered = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 130px;
  padding-top: 20px;
  padding-bottom: 70px;
`;

const MainContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  background: #e3f0ff;
  border-radius: 20px;
  @media (max-width: 768px) {
    width: 95%;
  }
`;
const HeadingForMobile = styled(Heading)`
  @media (max-width: 768px) {
    font-size: 25px;
  }
`;

const VariableTextForMobile = styled(VariableText)`
  @media (max-width: 768px) {
    width: auto;
    padding: 0 20px;
  }
`;
const HOST1 = process.env.REACT_APP_SECONDARY_API_BASE_URL;
const TransectionStatusPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [order_id, setOrderId] = useState('');
  const [paymentOrderId, setPaymentOrderId] = useState('');
  const [status, setStatus] = useState('');
  const [status_id, setStatusId] = useState('');
  const [signature, setSignature] = useState('');
  const [signature_algorithm, setSignatureAlgorithm] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [paymentGateway, setPaymentGateway] = useState('');
  const memberId = useSelector((state) => state.member.memberId);
  const [isLoading, setIsLoading] = useState(false);
  const handleBack = () => {
    navigate(ROUTES.CONTRIBUTION_FIRST_PAGE);
  };

  const fetchContData = async () => {
    setIsLoading(true);
    const url = `${SERVICES.CONTRIBUTION_DETAILS(
      memberId
    )}?&page=${0}&size=${1}`;
    const response = await get(url);
    try {
      if (response.ok) {
        const data = await response.json();
        setOrderId(data.data.content[0].orderId);
        setPaymentOrderId(data.data.content[0].id);
        setStatus(data.data.content[0].status);
      } else {
        toast.error('Something Went Wrong', {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          draggable: true,
          closeButton: false,
        });
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchReceiptData = async () => {
    const url = `${HOST1}/contribution/api/members/${memberId}/paymentOrders/${paymentOrderId}/receipt`;
    try {
      const xAuthToken = localStorage.getItem('X-Auth-Token');
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'X-Auth-Token': xAuthToken,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message);
      }

      const data = await response.json();
      const redirect = data.data;
      if (redirect) {
        window.open(redirect, '_blank');
      }
    } catch (error) {
      console.error(error);
      const errorMessage = error.message || 'An error occurred';
      toast.error(errorMessage, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    // const orderID = queryParams.get('order_id');
    // setOrderId(orderID);
    // const status = queryParams.get('status');
    // setStatus(status);
    const statusID = queryParams.get('status_id');
    setStatusId(statusID);
    const signatureformurl = queryParams.get('signature');
    setSignature(signatureformurl);
    const signatureAlgo = queryParams.get('signature_algorithm');
    setSignatureAlgorithm(signatureAlgo);
    setShowLoader(status === 'PENDING_VBV');

    const gateway = location.pathname.split('/').pop();
    setPaymentGateway(gateway);
    const fetchData = async () => {
      if (gateway === 'juspay') {
        const url = SERVICES.JUSPAY_POST_REQUEST;
        try {
          const response = await post(url, {
            // order_id: orderID,
            status: status,
            status_id: statusID,
            signature: signatureformurl,
            signature_algorithm: signatureAlgo,
          });
          if (!response.ok) {
            throw new Error('Request failed');
          }
          const data = await response.json();
        } catch (error) {
          console.error(error);
        }
      }
      if (gateway === 'eazypay') {
        const responseCode = queryParams.get('ResponseCode');
        const responseMessage = queryParams.get('ResponseMessage');
        const merchantRefNo = queryParams.get('ReferenceNo');
        const amount = queryParams.get('Amount');
        const txnId = queryParams.get('TransactionID');

        console.log('Eazypay Response:', {
          responseCode,
          responseMessage,
          merchantRefNo,
          amount,
          txnId,
        });

        // status mapping
        if (responseCode === 'E000') {
          setStatus('SUCCESS');
        } else if (responseCode === 'E0001' || responseCode === 'E0002') {
          setStatus('PENDING');
        } else {
          setStatus('FAILED');
        }

        setOrderId(merchantRefNo);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    fetchContData();
  }, []);
  return (
    <>
      <MainContainer>
        {showLoader ? (
          <LoaderCentered>
            <RotatingLines
              strokeColor="grey"
              strokeWidth="5"
              animationDuration="0.75"
              width={96}
              visible={true}
            />
            <VariableTextForMobile
              fontWeight="500"
              Size="20px"
              color="#484848"
              marginTop="30px"
            >
              We have received your contribution request and it is currently
              being processed. We appreciate your patience and cooperation in
              this matter. Once the verification is successfully completed, your
              contribution will be processed, and you will receive a
              confirmation email with the order ID: {order_id}. Thank you for
              your understanding and support. If you have any questions or
              concerns, please feel free to contact our customer service team
              for assistance.
            </VariableTextForMobile>
          </LoaderCentered>
        ) : (
          <>
            <CenteredContainer>
              <HeadingForMobile margin="50px">
                Online Transaction Status
              </HeadingForMobile>
            </CenteredContainer>
            <CenteredContainer>
              {/* waiting for status */}
              {status === null && (
                <LoaderCentered>
                  <RotatingLines
                    strokeColor="grey"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width={96}
                    visible={true}
                  />
                </LoaderCentered>
              )}

              {/* SUCCESS */}
              {status === 'SUCCESS' && (
                <VariableTextForMobile
                  fontWeight="500"
                  Size="20px"
                  color="#484848"
                >
                  We have received the contribution amount. Thank you very much
                  for your sincere and precious contribution for Kosen-rufu.
                  Your order ID is:
                  {order_id}. You will be receiving the receipt by email
                  shortly. If you would like to download your receipt now,
                  please click the button below.
                </VariableTextForMobile>
              )}

              {/* FAILED */}
              {status === 'FAILED' && (
                <VariableTextForMobile
                  fontWeight="500"
                  Size="20px"
                  color="#484848"
                >
                  Transaction failed. Please try again. If you need further
                  assistance, kindly reference your order ID: {order_id} when
                  communicating with our support team for quicker resolution.
                </VariableTextForMobile>
              )}

              {/* PENDING */}
              {status === 'PENDING' && (
                <VariableTextForMobile
                  fontWeight="500"
                  Size="20px"
                  color="#484848"
                >
                  Transaction pending. Please try again. If you need further
                  assistance, kindly reference your order ID: {order_id} when
                  communicating with our support team for quicker resolution.
                </VariableTextForMobile>
              )}

              {/* CANCELLED */}
              {status === 'CANCELLED' && (
                <VariableTextForMobile
                  fontWeight="500"
                  Size="20px"
                  color="#484848"
                >
                  Transaction cancelled. Please try again. If you need further
                  assistance, kindly reference your order ID: {order_id} when
                  communicating with our support team for quicker resolution.
                </VariableTextForMobile>
              )}
            </CenteredContainer>

            {/* <CenteredContainer>
              {status === null && (
                <LoaderCentered>
                  <RotatingLines
                    strokeColor="grey"
                    strokeWidth="5"
                    animationDuration="0.75"
                    width={96}
                    visible={true}
                  />
                </LoaderCentered>
              )}
              {status === 'SUCCESS' ? (
                <>
                  <VariableTextForMobile
                    fontWeight="500"
                    Size="20px"
                    color="#484848"
                  >
                    We have received the contribution amount. Thank you very
                    much for your sincere and precious contribution for
                    Kosen-rufu. Your order ID is: {order_id}. You will be
                    receiving the receipt by email shortly. If you would like to
                    download your receipt now, please click the button below.
                  </VariableTextForMobile>
                </>
              ) : (
                <VariableTextForMobile
                  fontWeight="500"
                  Size="20px"
                  color="#484848"
                >
                  Transection failed. Please try again. If you need further
                  assistance, kindly reference your order ID: {order_id} when
                  communicating with our support team for quicker resolution.
                </VariableTextForMobile>
              )}
            </CenteredContainer> */}
            {status === 'SUCCESS' && (
              <CenteredNew onClick={() => fetchReceiptData()}>
                <Button>Download Receipt</Button>
              </CenteredNew>
            )}
            <Centered onClick={handleBack}>
              <Button>Back to Contribution</Button>
            </Centered>
          </>
        )}
      </MainContainer>
      <CenteredContainer marginBottom="440px">
        <NoticeText>
          “FOREIGN NATIONAL MEMBERS ARE NOT ALLOWED TO USE THIS SITE FOR MAKING
          CONTRIBUTION. IF ANY FOREIGN NATIONAL MEMBERS MAKES CONTRIBUTION
          THROUGH THIS SITE, BSG WOULD NOT ACCEPT THEIR CONTRIBUTION.”
        </NoticeText>
      </CenteredContainer>
      {isLoading && <Loader />}
    </>
  );
};

export default TransectionStatusPage;
